import { Alert, Input, Space, Tag, Typography } from 'antd';
import JsonEditor from '@/components/JsonEditor';
import type { FileDraft } from '@/pages/SceneAnnotate/sceneContentCodec';

export default function SceneFileEditor({ file, readOnly, onChange, onSave }: {
  file: FileDraft; readOnly: boolean; onChange: (content: string) => void; onSave: () => void;
}) {
  return <Space direction="vertical" style={{ width: '100%' }}>
    <Space>
      <Typography.Text strong>{file.name}</Typography.Text>
      {file.content !== file.originalContent && <Tag color="orange">已修改</Tag>}
      {file.kind === 'protobuf-text' && <Typography.Text type="secondary">保存后请通过仿真验证配置</Typography.Text>}
    </Space>
    {file.name === 'scene_info.json' && <Typography.Text type="secondary">起止时间请在场景信息中修改；场景标识、record 来源和版本等由平台管理。</Typography.Text>}
    {file.error && <Alert type="error" showIcon message={file.error} />}
    {file.kind === 'json' || file.kind === 'managed-json'
      ? <JsonEditor value={file.content} onChange={onChange} readOnly={readOnly} onSave={onSave} minRows={12} maxRows={24} />
      : <Input.TextArea aria-label={`编辑 ${file.name}`} value={file.content} onChange={event => onChange(event.target.value)}
          readOnly={readOnly} autoSize={{ minRows: 12, maxRows: 24 }} spellCheck={false}
          style={{ fontFamily: 'monospace' }} onKeyDown={event => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') { event.preventDefault(); onSave(); }
          }} />}
  </Space>;
}
